import React, { useState } from "react";
import AddPersonForm from "./AddPersonForm.jsx";

const Step4 = ({ formData, updateField, goNext, goPrev }) => {
  const [sections, setSections] = useState({
    sellers: formData.sellers || [],
    buyers: formData.buyers || [],
    lenders: formData.lenders || [],
    realEstateAgents: formData.realEstateAgents || [],
  });

  const [showAddForm, setShowAddForm] = useState(false);
  const [currentSection, setCurrentSection] = useState(null);
  const [editingPerson, setEditingPerson] = useState(null);

  const openAddForm = sectionName => {
    setCurrentSection(sectionName);
    setEditingPerson(null);
    setShowAddForm(true);
  };

  const openEditForm = (sectionName, person) => {
    setCurrentSection(sectionName);
    setEditingPerson(person);
    setShowAddForm(true);
  };

  const closeAddForm = () => {
    setShowAddForm(false);
    setCurrentSection(null);
    setEditingPerson(null);
  };

  const addPersonToSection = person => {
    const updatedSections = {
      ...sections,
      [currentSection]: editingPerson
        ? sections[currentSection].map(p => (p.id === person.id ? person : p))
        : [...sections[currentSection], person],
    };
    setSections(updatedSections);
    updateField(currentSection, updatedSections[currentSection]);
    closeAddForm();
  };

  const removeFromSection = (sectionName, itemId) => {
    const updatedSections = {
      ...sections,
      [sectionName]: sections[sectionName].filter(item => item.id !== itemId),
    };
    setSections(updatedSections);
    updateField(sectionName, updatedSections[sectionName]);
  };
  //
  //   const renderPersonSummary = person => {
  //     const name =
  //       person.displayName ||
  //       `${person.firstName} ${person.lastName}`.trim() ||
  //       "Unnamed Person";
  //     const details = [];
  //
  //     if (person.email) details.push(person.email);
  //     if (person.phone) details.push(person.phone);
  //     if (person.city && person.state)
  //       details.push(`${person.city}, ${person.state}`);
  //
  //     return (
  //       <div className="person-summary">
  //         <div className="person-summary__name">{name}</div>
  //         {details.length > 0 && (
  //           <div className="person-summary__details">{details.join(" • ")}</div>
  //         )}
  //       </div>
  //     );
  //   };

  const renderSection = (title, sectionName, items) => (
    <div className="form-order-services__section">
      <div className="form-order-services__section-header">
        <h3 className="form-order-services__section-title">
          {title}{" "}
          <button type="button" onClick={() => openAddForm(sectionName)}>
            + Add
          </button>
        </h3>
      </div>
      {items.length > 0 && (
        <div className="form-order-services__section-people">
          {items.map(item => {
            const name =
              `${item.firstName || ""} ${item.lastName || ""}`.trim() ||
              "Unnamed Person";
            return (
              <div key={item.id} className="form-order-services__person-item">
                <div className="form-order-services__person-name">{name}</div>
                <div className="form-order-services__person-actions">
                  <button
                    type="button"
                    className="form-order-services__edit-person"
                    onClick={() => openEditForm(sectionName, item)}
                  >
                    Edit
                  </button>
                  <button
                    type="button"
                    className="form-order-services__remove-person"
                    onClick={() => removeFromSection(sectionName, item.id)}
                  >
                    Remove
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );

  // If the add form is open, render it instead of the main step content
  if (showAddForm) {
    return (
      <div className="form-order-services__step form-order-services__step--4 form-order-services__step--add-person">
        <AddPersonForm
          isOpen={true}
          onClose={closeAddForm}
          onAdd={addPersonToSection}
          sectionType={currentSection}
          initialData={editingPerson}
          existingPeople={sections[currentSection] || []}
        />
      </div>
    );
  }

  return (
    <div className="form-order-services__step form-order-services__step--4">
      <h2 className="form-order-services__step-title txt-h4">
        If you prefer, you can add details about the sellers and buyers involved
        now to speed up the process later.
      </h2>

      <div className="form-order-services__sections">
        {renderSection("Sellers/Owners", "sellers", sections.sellers)}
        {renderSection("Buyers/Borrowers", "buyers", sections.buyers)}
        {renderSection("Lenders", "lenders", sections.lenders)}
        {renderSection(
          "Real Estate Agents",
          "realEstateAgents",
          sections.realEstateAgents,
        )}
      </div>

      <div className="form-order-services__actions">
        <button type="button" className="btn btn--secondary" onClick={goPrev}>
          BACK
        </button>
        <div className="form-order-services__actions-group">
          <button type="button" className="btn btn--secondary" onClick={goNext}>
            SKIP
          </button>
          <button type="button" className="btn btn--primary" onClick={goNext}>
            NEXT
          </button>
        </div>
      </div>
    </div>
  );
};

export default Step4;
